// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.homologation-cards {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 40px 10px;
  background: linear-gradient(#6eba35, #10677a);
  border-radius: 0px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.homologation-card {
  width: 340px;
  height: 500px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.homologation-card:first-child {
  display: flex;
  width: 28%;
  flex-direction: column;
  padding: 0;
  background: none;
  border: none;
}

.homologation-card:first-child .image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.homologation-card:first-child img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.homologation-card.first-card {
  border: none;
  margin-right: 0px;
}

.homologation-card.first-card .fill-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 30px;
  left: 20px;

  color: #0e0c0c;

  font-size: 30px;
  border-radius: 5px;
}

.image-wrapper {
  position: relative;
  width: 80%;
  height: 200px;
}
.homologation-card:nth-child(n + 2) .image-wrapper {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
}
.homologation-card:nth-child(1) .card-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.homologation-card:nth-child(n + 2) .card-image {
  width: 250px;
  height: 250px;
  object-fit: contain;
}
.homologation-card:nth-child(2) .card-image {
  width: 350px;
  height: 300;
  object-fit: contain;
  margin-top: 10px;
}

.homologation-card:nth-child(4) .card-image {
  width: 200px;
  height: 220;
  object-fit: contain;
  margin-top: 10px;
}

.card-image {
  width: 80%;
  height: 80%;
  object-fit: cover;
}

.resizable-image {
  object-fit: contain;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  margin: 10px;
  color: #007e01;
}

.card-description {
  font-size: 15px;
  margin: 20px;
  flex-grow: 1;
}

.learn-more-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 3cqmin;
}

.learn-more-line {
  width: 100%;
  height: 2px;
  background-color: rgb(202, 193, 193);
  margin-bottom: 10px;
}

.learn-more-btn {
  display: inline-block;
  padding: 8px 16px;
  font-size: 14px;
  color: white;
  background-color: #22b81d;
  border: none;
  border-radius: 5px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
}

.homologation-detail {
  text-align: center;
  padding: 20px;
}

.detail-image {
  max-width: 100%;
  height: auto;
}

.detail-title {
  font-size: 1rem;
  margin-top: 20px;
}

.detail-description {
  font-size: 1.2rem;
  color: #555;
  margin-top: 20px;
}

.back-button {
  background-color: #22b81d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 20px;
}

.back-button:hover {
  background-color: #0056b3;
}

.learn-more-btn:hover {
  background-color: #212724;
}

.homologation-card:nth-child(2) .card-title {
  color: #007e01;
  font-weight: bold;
  font-size: 22px;
  margin: 70% 10%;
  margin-top: 20%;
}
.homologation-card:nth-child(3) .card-title {
  color: #007e01;
  font-weight: bold;
  font-size: 22px;
  margin: 120% 10%;
  margin-top: 20%;
}
.homologation-card:nth-child(4) .card-title {
  color: #007e01;
  font-weight: bold;
  font-size: 22px;
  margin: 80% 10%;
  margin-top: 20%;
}
.homologation-card:nth-child(2) .card-description {
  font-size: 1.2rem;
  color: #555;
  margin-top: -60%;
}
.homologation-card:nth-child(3) .card-description {
  font-size: 1.2rem;
  color: #555;
  margin-top: -100%;
}
.homologation-card:nth-child(4) .card-description {
  font-size: 1.2rem;
  color: #555;
  margin-top: -60%;
}
@media (max-width: 768px) {
  .homologation-cards {
    flex-direction: column;
    padding: 60px 30px;
  }

  .homologation-card {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .card-title {
    font-size: 20px;
  }

  .card-description {
    font-size: 16px;
  }

  .learn-more-btn {
    font-size: 12px;
    padding: 6px 12px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .homologation-cards {
    flex-wrap: wrap;
    justify-content: center;
  }

  .homologation-card {
    width: 45%;
    margin: 10px;
  }

  .card-title {
    font-size: 25px;
  }

  .card-description {
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homologation/Homologation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,cAAc;;EAEd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  width: 1200px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.homologation-cards {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 40px 10px;\n  background: linear-gradient(#6eba35, #10677a);\n  border-radius: 0px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.homologation-card {\n  width: 340px;\n  height: 500px;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.homologation-card:first-child {\n  display: flex;\n  width: 28%;\n  flex-direction: column;\n  padding: 0;\n  background: none;\n  border: none;\n}\n\n.homologation-card:first-child .image-wrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.homologation-card:first-child img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.homologation-card.first-card {\n  border: none;\n  margin-right: 0px;\n}\n\n.homologation-card.first-card .fill-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-overlay {\n  position: absolute;\n  top: 30px;\n  left: 20px;\n\n  color: #0e0c0c;\n\n  font-size: 30px;\n  border-radius: 5px;\n}\n\n.image-wrapper {\n  position: relative;\n  width: 80%;\n  height: 200px;\n}\n.homologation-card:nth-child(n + 2) .image-wrapper {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 10px;\n}\n.homologation-card:nth-child(1) .card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n.homologation-card:nth-child(n + 2) .card-image {\n  width: 250px;\n  height: 250px;\n  object-fit: contain;\n}\n.homologation-card:nth-child(2) .card-image {\n  width: 350px;\n  height: 300;\n  object-fit: contain;\n  margin-top: 10px;\n}\n\n.homologation-card:nth-child(4) .card-image {\n  width: 200px;\n  height: 220;\n  object-fit: contain;\n  margin-top: 10px;\n}\n\n.card-image {\n  width: 80%;\n  height: 80%;\n  object-fit: cover;\n}\n\n.resizable-image {\n  object-fit: contain;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 10px;\n  color: #007e01;\n}\n\n.card-description {\n  font-size: 15px;\n  margin: 20px;\n  flex-grow: 1;\n}\n\n.learn-more-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin: 3cqmin;\n}\n\n.learn-more-line {\n  width: 100%;\n  height: 2px;\n  background-color: rgb(202, 193, 193);\n  margin-bottom: 10px;\n}\n\n.learn-more-btn {\n  display: inline-block;\n  padding: 8px 16px;\n  font-size: 14px;\n  color: white;\n  background-color: #22b81d;\n  border: none;\n  border-radius: 5px;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n}\n\n.homologation-detail {\n  text-align: center;\n  padding: 20px;\n}\n\n.detail-image {\n  max-width: 100%;\n  height: auto;\n}\n\n.detail-title {\n  font-size: 1rem;\n  margin-top: 20px;\n}\n\n.detail-description {\n  font-size: 1.2rem;\n  color: #555;\n  margin-top: 20px;\n}\n\n.back-button {\n  background-color: #22b81d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.back-button:hover {\n  background-color: #0056b3;\n}\n\n.learn-more-btn:hover {\n  background-color: #212724;\n}\n\n.homologation-card:nth-child(2) .card-title {\n  color: #007e01;\n  font-weight: bold;\n  font-size: 22px;\n  margin: 70% 10%;\n  margin-top: 20%;\n}\n.homologation-card:nth-child(3) .card-title {\n  color: #007e01;\n  font-weight: bold;\n  font-size: 22px;\n  margin: 120% 10%;\n  margin-top: 20%;\n}\n.homologation-card:nth-child(4) .card-title {\n  color: #007e01;\n  font-weight: bold;\n  font-size: 22px;\n  margin: 80% 10%;\n  margin-top: 20%;\n}\n.homologation-card:nth-child(2) .card-description {\n  font-size: 1.2rem;\n  color: #555;\n  margin-top: -60%;\n}\n.homologation-card:nth-child(3) .card-description {\n  font-size: 1.2rem;\n  color: #555;\n  margin-top: -100%;\n}\n.homologation-card:nth-child(4) .card-description {\n  font-size: 1.2rem;\n  color: #555;\n  margin-top: -60%;\n}\n@media (max-width: 768px) {\n  .homologation-cards {\n    flex-direction: column;\n    padding: 60px 30px;\n  }\n\n  .homologation-card {\n    width: 100%;\n    height: auto;\n    margin-bottom: 20px;\n  }\n\n  .card-title {\n    font-size: 20px;\n  }\n\n  .card-description {\n    font-size: 16px;\n  }\n\n  .learn-more-btn {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .homologation-cards {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .homologation-card {\n    width: 45%;\n    margin: 10px;\n  }\n\n  .card-title {\n    font-size: 25px;\n  }\n\n  .card-description {\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
